import { render, staticRenderFns } from "./InformationList.vue?vue&type=template&id=c469245e&scoped=true&"
import script from "./InformationList.vue?vue&type=script&lang=js&"
export * from "./InformationList.vue?vue&type=script&lang=js&"
import style0 from "../../assets/informationList.css?vue&type=style&index=0&id=c469245e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c469245e",
  null
  
)

export default component.exports